"use client";

import { Headphones, HelpCircle } from "lucide-react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";

import { ListItem } from "../ListItem";
import type { TravelInfoSection } from "../type";
import { HelpCard } from "./HelpCard";

interface MobileLayoutProps {
  travelInfoSections: TravelInfoSection[];
}

const MobileLayout = ({ travelInfoSections }: MobileLayoutProps) => (
  <div className="mt-2 block lg:hidden">
    <div className="grid grid-cols-2 gap-4 py-1">
      <HelpCard
        icon={<Headphones className="h-5 w-5" />}
        label="Help center"
        onClick={() => console.log("Help center clicked")}
      />
      <HelpCard
        icon={<HelpCircle className="h-5 w-5" />}
        label="Frequent questions"
        onClick={() => console.log("Frequent questions clicked")}
      />
    </div>

    <Accordion type="multiple" className="w-full">
      {travelInfoSections.map((section, index) => (
        <AccordionItem
          key={section.title}
          value={section.title}
          className="border-b border-slate-200"
        >
          <AccordionTrigger className="text-primary py-4 text-base font-semibold">
            {`${index + 1}. ${section.title}`}
          </AccordionTrigger>
          <AccordionContent className="pl-2">
            {section.items.map((item) => (
              <ListItem
                key={item.label}
                icon={item.icon}
                text={item.label}
                className="cursor-pointer"
              />
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);

export default MobileLayout;
